export enum States {
	AL = 'AL',
	AK = 'AK',
	AZ = 'AZ',
	AR = 'AR',
	CA = 'CA',
	CO = 'CO',
	CT = 'CT',
	DE = 'DE',
	DC = 'DC',
	FL = 'FL',
	GA = 'GA',
	HI = 'HI',
	ID = 'ID',
	IL = 'IL',
	IN = 'IN',
	IA = 'IA',
	KS = 'KS',
	KY = 'KY',
	LA = 'LA',
	ME = 'ME',
	MD = 'MD',
	MA = 'MA',
	MI = 'MI',
	MN = 'MN',
	MS = 'MS',
	MO = 'MO',
	MT = 'MT',
	NE = 'NE',
	NV = 'NV',
	NH = 'NH',
	NJ = 'NJ',
	NM = 'NM',
	NC = 'NC',
	ND = 'ND',
	NY = 'NY',
	OH = 'OH',
	OK = 'OK',
	OR = 'OR',
	PA = 'PA',
	RI = 'RI',
	SC = 'SC',
	SD = 'SD',
	TN = 'TN',
	TX = 'TX',
	UT = 'UT',
	VT = 'VT',
	VA = 'VA',
	WA = 'WA',
	WV = 'WV',
	WI = 'WI',
	WY = 'WY',
	PR = 'PR',
	VI = 'VI',
	GU = 'GU',
	MP = 'MP',
}
